import { makeStyles } from '@material-ui/core'

// Two tracks on mobile: the code (with its booking and time beneath) and the state chip.
// `minmax(0, …)` for the same reason as the desktop grid — a voucher code and a booking
// id are both unbreakable tokens, and a bare `fr` lets either push its track past its
// share and misalign the rows.
const COLUMNS_MOBILE = 'minmax(0, 1fr) auto'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS_MOBILE,
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: COLUMNS_MOBILE,
    minHeight: 64,
    alignItems: 'center',
    padding: '0 12px',
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    marginBottom: 4
  },
  cell: {
    minWidth: 0,
    paddingRight: 12,
    overflow: 'hidden',
    '& > *': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block'
    }
  },
  refreshCell: { margin: 'auto' },
  skeletonBlock: {
    height: 20,
    width: '70%',
    backgroundColor: theme.palette.action.hover,
    borderRadius: 4
  },
  noDataImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 62
  }
}))

export default useStyles
